module.exports = __webpack_public_path__ + "img/icon-checkmark-gray.3593d7fc.svg";